import axios from "axios";
import { environment } from "../../environment";

export const SystemLogsService = () => {
  const get = async () => {
    try {
      const res = await axios.get(environment.usersUrl + "system-logs");
      if (res && res.data) {
        return res.data;
      } else {
        throw new Error("No data");
      }
    } catch (err) {
      throw err;
    }
  };

  return {
    get,
  };
};
